import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    const success = await login(username, password);

    if (success) {
      toast.success('Login successful!', {
        position: 'top-right',
        autoClose: 2000,
      });
      setTimeout(() => navigate('/dashboard'), 2000);
    } else {
      toast.error('Login failed. Please check credentials.', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F1EE] p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md border border-[#ddd]">
        <h2 className="text-3xl font-bold text-center text-[#3C3B3F] mb-2">
          Welcome Back 👋
        </h2>
        <p className="text-center text-sm text-[#6B6B6B] mb-6">
          Sign in to manage your orders and stock
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[#5A5A5A] mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              className="w-full px-4 py-2 border border-[#ccc] rounded-md shadow-sm focus:ring-2 focus:ring-[#A89F91] focus:outline-none"
              placeholder="Enter your username"
            />
          </div>

          <div>
            <label className="block text-[#5A5A5A] mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                className="w-full px-4 py-2 border border-[#ccc] rounded-md shadow-sm focus:ring-2 focus:ring-[#A89F91] focus:outline-none pr-10"
                placeholder="Enter your password"
              />
              <div
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-500 hover:text-gray-700"
              >
                {showPassword ? (
                  <EyeSlashIcon className="h-5 w-5" />
                ) : (
                  <EyeIcon className="h-5 w-5" />
                )}
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-[#3C3B3F] text-white font-medium py-2 rounded-md hover:bg-[#2E2D30] transition"
          >
            Sign In
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-[#8A8A8A]">
          &copy; {new Date().getFullYear()} Stock & Order Management
        </p>
      </div>

      <ToastContainer />
    </div>
  );
}
